export const isString = e => {
  return Object.prototype.toString.call(e) === '[object String]'
}

export const isFunction = e => {
  return typeof e === 'function'
}

export const isArray = e => {
  return Object.prototype.toString.call(e) === '[object Array]'
}

export const safetyCall = (fun, params, d) => {
  if (typeof fun !== 'function') return d
  try {
    return fun(params)
  } catch {
    return d
  }
}

export const ignoreByRule = (source, pattens) => {
  if (!source || !pattens) return false
  // String || RegExp || Function
  if (isString(pattens) || pattens.source || isFunction(pattens)) {
    pattens = [pattens]
  }
  if (!isArray(pattens)) {
    return false
  }
  const regArr = []
  for (let i = 0, length = pattens.length; i < length; i++) {
    const r = pattens[i]
    if (isString(r)) {
      regArr.push(r.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1')) // eslint-disable-line
    } else if (r.source) {
      regArr.push(r.source)
    } else if (isFunction(r) && safetyCall(r, [source], false) === true) {
      return true
    }
  }
  const reg = new RegExp(regArr.join('|'), 'i')
  return !!(regArr.length && reg.test && reg.test(source))
}
